import * as actionTypes from "../actionTypes";

const initialState = {
  configDataSegment: {},
  currentDataSegment: {},
  persistIn: "session"
};

export default function dataSegmentReducer(state = initialState, action) {
  let data = action.data;
  switch (action.type) {
    case actionTypes.SET_CONFIGDATASEGMENT:
      return {
        ...state,
        configDataSegment: {
          dataSegmentId: data.newDataSegmentId,
          authToken: data.newAuthToken,
        }
      };
    case actionTypes.CLEAR_CONFIGDATASEGMENT:
      return {
        ...state,
        configDataSegment: {}
      };
    case actionTypes.SET_DATASEGMENT:
      return {
        ...state,
        currentDataSegment: {
          id: data.newId,
          displayName: data.newDisplayName,
          technicalName: data.newTechnicalName,
          solutionId: data.newSolutionId,
          solutionDisplayName: data.newSolutionDisplayName,
          solutionTechnicalName: data.newSolutionTechnicalName,
          authToken: data.newAuthToken,
          originUri: data.newOriginUri,
          title: data.newTitle,
          imageRef: data.newImageRef,
        }
      };
    case actionTypes.UPDATE_DATASEGMENT:
      let existing = state.currentDataSegment;
      return {
        ...state,
        currentDataSegment: {
          ...existing,
          ...data
        }
      };
    case actionTypes.CLEAR_DATASEGMENT:
      return {
        ...state,
        currentDataSegment: {}
      };
    default:
      return state;
  }
}
